import React from 'react';
import InputEditor from 'app/playbook-editor/transform-drawer/components/InputEditor';
import PipelineOutputTab from './PipelineOutputTab';
import PlaybookOutputTab from './PlaybookOutputTab';
import ServerResponseTab from './ServerResponseTab';

// Builds the controlled-tab config for the Advanced chain. Pulled out of
// AdvancedTabsSection so the component stays a thin render.
export default function buildAdvancedTabs(chainState) {
  return [
    { label: 'Input Event', content: <InputEditor /> },
    {
      label: 'Pipeline Output',
      content: <PipelineOutputTab />,
      TabProps: {
        disabled: chainState.pipelineOutputDisabled,
        disabledTooltip: chainState.pipelineOutputDisabledTooltip,
        onClick: chainState.executePipelineTransform,
      },
    },
    {
      label: 'Playbook Output',
      content: <PlaybookOutputTab />,
      TabProps: {
        disabled: chainState.playbookOutputDisabled,
        disabledTooltip: chainState.playbookOutputDisabledTooltip,
        onClick: chainState.executePlaybookTransform,
      },
    },
    {
      label: 'Server Response',
      content: <ServerResponseTab />,
      TabProps: {
        disabled: chainState.serverResponseDisabled,
        disabledTooltip: chainState.serverResponseDisabledTooltip,
      },
    },
  ];
}
